import React, { Component } from "react";
import Empty from "../../../base/features/blocks/Empty";
import Spinner from "../../../base/features/micro/Spinner";
import ManagementNavBottom from "../blocks/ManagementNavBottom";
import { MdClose } from "react-icons/md";
import { managementComments } from "./services";
import InfiniteScroll from "react-infinite-scroll-component";
import Comment from "../../shop/comment/Comment";

class ManagementComments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: null,
      searchKey: "",
      hasMore: false,
      nextUrl: "",
      shopUid: window.location.pathname.split("/")[2],
    };
  }
  componentDidMount() {
    this.getComments();
  }
  getComments() {
    let q = this.state.searchKey;
    managementComments(this.state.shopUid, q).then((items) => {
      if (q === this.state.searchKey && items) {
        this.setState({
          comments: items.results,
          hasMore: items.next ? true : false,
          nextUrl: items.next,
        });
      }
    });
  }
  fetchMoreData() {
    managementComments(this.state.shopUid, "", this.state.nextUrl).then(
      (items) => {
        if (items) {
          var newComments = this.state.comments;
          newComments = newComments.concat(items.results);

          this.setState({
            comments: newComments,
            nextUrl: items.next,
            hasMore: items.next ? true : false,
          });
        }
      }
    );
  }
  render() {
    return (
      <div className="container-fluid px-0">
        <header
          className="row mx-0 px-4 py-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0", zIndex: "9999" }}
        >
          <div className="col text-end align-self-center px-0">
            <h1 className="fs-5 fw-bold mb-0">نظرات</h1>
          </div>
        </header>
        <body style={{ marginTop: "60px", marginBottom: "80px" }}>
          {this.state.comments ? (
            <InfiniteScroll
              dataLength={this.state.comments.length}
              next={() => this.fetchMoreData()}
              hasMore={this.state.hasMore}
              className="row mx-0"
              loader={<Spinner />}
            >
              <div className="col-12 px-4 py-3 text-center position-relative">
                <input
                  type="text"
                  value={this.state.searchKey}
                  onChange={(e) =>
                    this.setState({ searchKey: e.target.value }, () => {
                      this.getComments();
                    })
                  }
                  className="form-control px-3 py-2 rounded14 w-100"
                  style={{ height: "44px" }}
                  placeholder="جستجو کنید"
                />
                {this.state.searchKey.length !== 0 && (
                  <MdClose
                    size={26}
                    style={{ left: "37px", top: "0", bottom: "0" }}
                    className="position-absolute my-auto"
                    onClick={() =>
                      this.setState({ searchKey: "" }, () => {
                        this.getComments();
                      })
                    }
                  />
                )}
              </div>
              {this.state.comments.length === 0 && (
                <Empty type="comment" text={"نظری یافت نشد."} />
              )}
              {this.state.comments.map((comment, c) => (
                <div key={c} className="col-12 px-0 border-bottom">
                  <Comment
                    comment={comment}
                    management={true}
                    key={c}
                    get_comments={() => this.getComments()}
                  />
                </div>
              ))}
            </InfiniteScroll>
          ) : (
            <Spinner />
          )}
        </body>
        <ManagementNavBottom />
      </div>
    );
  }
}

export default ManagementComments;
